import eggplantInvoltini from './eggplantInvoltini';
import cacioEPepe from './cacioEPepe';
import mushroomPotPie from './mushroomPotPie';
import sorghumGlazedBranzino from './sorghumGlazedBranzino';
import steakAndRisotto from './steakAndRisotto';

const episodes = {
  eggplantInvoltini,
  sorghumGlazedBranzino,
  cacioEPepe,
  mushroomPotPie,
  steakAndRisotto
};

export const getEpisodes = () => Object.values(episodes);
export const getEpisode = (episode) => episodes[episode];
export const getSeason = (season) =>
  getEpisodes().filter((v) => v.season === season);

export default episodes;
